import { useMediaQuery, useTheme } from '@mui/material';

type ThemeMediaQuery = {
  xsmall: boolean;
  small: boolean;
  medium: boolean;
  large: boolean;
};

const useThemeMediaQuery = (): ThemeMediaQuery => {
  const bpFunc = useTheme().breakpoints.down;

  return {
    xsmall: useMediaQuery(bpFunc('xs')),
    small: useMediaQuery(bpFunc('sm')),
    medium: useMediaQuery(bpFunc('md')),
    large: useMediaQuery(bpFunc('lg')),
  };
};

export default useThemeMediaQuery;
